import {
  core_apimessages_CheckoutPaymentMethod as CheckoutPaymentMethod,
  core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType,
} from '@reverbdotcom/commons/src/gql/graphql';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { reverbAppQueryValue } from '../checkoutActionHooks';

export interface StandalonePayPalInlineFormCheckout {
  availablePaymentMethods?: Array<CheckoutPaymentMethod>;
}

/**
 * @param paymentMethodType
 * @param checkout
 * @returns Boolean, true if the payment method is standalone PayPal (or standalone Pay Later) and user is not browsing via native app.
 */
export function useStandalonePayPalInlineForm(
  paymentMethodType: CheckoutPaymentMethodType = CheckoutPaymentMethodType.PAYPAL,
  checkout?: StandalonePayPalInlineFormCheckout,
) {
  const url = useURL();

  const paypalSelected = paymentMethodType === CheckoutPaymentMethodType.PAYPAL;

  const standalonePayPalSupported = checkout ? !!checkout.availablePaymentMethods?.some((paymentMethod) => paymentMethod?.type === CheckoutPaymentMethodType.PAYPAL) : true;
  const standalonePayLater = (paymentMethodType === CheckoutPaymentMethodType.PAYPAL_PAY_LATER) && standalonePayPalSupported;

  return (paypalSelected || standalonePayLater) && !reverbAppQueryValue(url);
}
